import type { ReactElement } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import { Spinner } from '../components/ui/Spinner.js';
import { authClient } from '../lib/auth-client.js';
import { routePaths } from './route-paths.js';

export function RequireSession(): ReactElement {
    const session = authClient.useSession();
    const location = useLocation();

    // A refresh can still be replacing a logged-out read. Redirecting in that
    // gap sends a signed-in user back to the form.
    if (session.isPending || (session.isRefetching && !session.data)) {
        return <Spinner label="Checking your session" />;
    }
    if (!session.data) {
        const returnTo = encodeURIComponent(`${location.pathname}${location.search}`);
        return <Navigate to={`${routePaths.signIn}?returnTo=${returnTo}`} replace />;
    }
    return <Outlet />;
}
